






























































import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    disabled: Boolean,
    value: Array
  },

  setup(props, { emit }) {
    const inKaiAdminsRole = computed({
      get: () => props.value?.includes('KaiAdmins') ?? false,
      set: (inRole: boolean) => toggleRole('KaiAdmins', inRole)
    })

    const inTeamAdminsRole = computed({
      get: () => props.value?.includes('TeamAdmins') ?? false,
      set: (inRole: boolean) => toggleRole('TeamAdmins', inRole)
    })

    const inTeamMembersRole = computed({
      get: () => props.value?.includes('TeamMembers') ?? false,
      set: (inRole: boolean) => toggleRole('TeamMembers', inRole)
    })

    const inKaiEditorsRole = computed({
      get: () => props.value?.includes('KaiEditors') ?? false,
      set: (inRole: boolean) => toggleRole('KaiEditors', inRole)
    })

    const inCoachesRole = computed({
      get: () => props.value?.includes('Coaches') ?? false,
      set: (inRole: boolean) => toggleRole('Coaches', inRole)
    })

    const inFeatureSwitchesRole = computed({
      get: () => props.value?.includes('FeatureSwitches') ?? false,
      set: (inRole: boolean) => toggleRole('FeatureSwitches', inRole)
    })

    const toggleRole = (role: string, inRole: boolean) => {
      if (inRole) roleSelected(role)
      else roleDeselected(role)
    }

    const roleSelected = (role: string) => emit('role-selected', role)
    const roleDeselected = (role: string) => emit('role-deselected', role)

    return {
      inKaiAdminsRole,
      inTeamAdminsRole,
      inKaiEditorsRole,
      inCoachesRole,
      inFeatureSwitchesRole,
      inTeamMembersRole
    }
  }
})
